import { Colors } from '@cognite/cogs.js';
import type { StepAction, ItemActions, ItemType } from 'types';
import { Modes } from 'types';
import { v4 as uuidv4 } from 'uuid';

const blue = Colors['decorative--blue--500'];
const yellow = Colors['decorative--yellow--500'];
const purple = Colors['decorative--purple--600'];
const pink = Colors['decorative--pink--300'];
const green = Colors['decorative--green--500'];
const orange = Colors['decorative--orange--400'];

export const OpenAction: StepAction = {
  id: uuidv4(),
  text: 'Open',
  template: 'Open [item]',
  color: blue,
  slug: 'open',
};

export const CloseAction: StepAction = {
  id: uuidv4(),
  text: 'Close',
  template: 'Close [item]',
  color: yellow,
  slug: 'close',
};

export const TagOpenAction: StepAction = {
  id: uuidv4(),
  text: 'Tag open',
  template: 'Tag open [item]',
  color: blue,
  slug: 'tag-open',
  defaultTagged: true,
};

export const TagCloseAction: StepAction = {
  id: uuidv4(),
  text: 'Tag close',
  template: 'Tag close [item]',
  color: yellow,
  slug: 'tag-close',
  defaultTagged: true,
};

export const TagAirSupply: StepAction = {
  id: uuidv4(),
  text: 'Tag closed air supply',
  template: 'Tag closed air supply to [item]',
  color: yellow,
  slug: 'tag-closed-air-supply-to',
  defaultTagged: true,
};

export const RemoveItem: StepAction = {
  id: uuidv4(),
  text: 'Valve/item',
  template: 'Remove [item]',
  color: purple,
  slug: 'remove',
};

export const RemovePlugCap: StepAction = {
  id: uuidv4(),
  text: 'Plug/Cap',
  template: 'Remove plug/cap from [item]',
  color: purple,
  slug: 'remove-plugcap-from',
};

export const ReinstatePlugCap: StepAction = {
  id: uuidv4(),
  text: 'Reinstate cap/plug',
  template: 'Reinstate cap/plug to [item]',
  color: pink,
  slug: 'reinstate-capplug-to',
};

export const RemoveTubing: StepAction = {
  id: uuidv4(),
  text: 'Tubing',
  template: 'Remove tubing from [item], cap/plug and tag',
  color: purple,
  slug: 'remove-tubing-from-capplug-and-tag',
  defaultTagged: true,
};

export const RemoveManwayDoor: StepAction = {
  id: uuidv4(),
  text: 'Remove manway door',
  template: 'Remove manway door from [item]',
  color: purple,
  slug: 'remove-manway-door-from',
};

export const ReinstateManwayDoor: StepAction = {
  id: uuidv4(),
  text: 'Reinstate manway door',
  template: 'Reinstate manway door to [item]',
  color: pink,
  slug: 'reinstate-manway-door-to',
};

export const RemoveTagAndOpen: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and open',
  template: 'Remove tag and open [item]',
  color: blue,
  slug: 'remove-tag-and-open',
  defaultTagged: true,
};

export const RemoveTagAndOpenAirSupply: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and open',
  template: 'Remove tag and open air supply [item]',
  color: blue,
  slug: 'remove-tag-and-open-air-supply',
  defaultTagged: true,
};

export const RemoveTagAndLockWireOpen: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and lock wire open',
  template: 'Remove tag and lock wire open [item]',
  color: blue,
  slug: 'remove-tag-and-lock-wire-open',
  defaultTagged: true,
};

export const RemoveTagAndLeaveOpen: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and leave open',
  template: 'Remove tag and leave open [item]',
  color: blue,
  slug: 'remove-tag-and-leave-open',
  defaultTagged: true,
};

export const RemoveTagAndClose: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and close',
  template: 'Remove tag and close [item]',
  color: yellow,
  slug: 'remove-tag-and-close',
  defaultTagged: true,
};

export const RemoveTagAndLockWireClose: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and lock wire close',
  template: 'Remove tag and lock wire close [item]',
  color: yellow,
  slug: 'remove-tag-and-lock-wire-close',
  defaultTagged: true,
};

export const RemoveTagAndLeaveClose: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and leave closed',
  template: 'Remove tag and leave closed [item]',
  color: yellow,
  slug: 'remove-tag-and-leave-close',
  defaultTagged: true,
};

export const RemoveTagAndLeaveCloseAirSupply: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and leave closed air',
  template: 'Remove tag and leave closed air supply [item]',
  color: yellow,
  slug: 'remove-tag-and-leave-close-air-supply',
  defaultTagged: true,
};

export const TubingRemoveTagAndCap: StepAction = {
  id: uuidv4(),
  text: 'Tubing - remove tag and cap/plug and reconnect',
  template: 'Remove tag and cap/plug, reconnect tubing to [item]',
  color: pink,
  slug: 'remove-tag-and-cap-reconnect-tubing-to',
  defaultTagged: true,
};

export const ElectricallyIsolate: StepAction = {
  id: uuidv4(),
  text: 'Electrically isolate',
  template: 'Electrically isolate and tag [item]',
  color: orange,
  slug: 'electrically-isolate-and-tag',
  defaultTagged: true,
};

export const ElectricallyReinstate: StepAction = {
  id: uuidv4(),
  text: 'Electrically reinstate',
  template: 'Remove tag and electrically reinstate [item]',
  color: purple,
  slug: 'electrically-reinstate',
};
// Spade
export const InstallSpadeAndTag: StepAction = {
  id: uuidv4(),
  text: 'Install and tag',
  template: 'Install and tag a [class] spade at [item]',
  color: orange,
  slug: 'install-and-tag-a-rated-spade-to',
  defaultTagged: true,
};

export const InstallSpadeAndTagUpstream: StepAction = {
  id: uuidv4(),
  text: 'Install and tag upstream',
  template: 'Install and tag a [class] spade upstream of [item]',
  color: orange,
  slug: 'install-and-tag-a-upstream-rated-spade-to',
  defaultTagged: true,
};

export const InstallSpadeAndTagDownstream: StepAction = {
  id: uuidv4(),
  text: 'Install and tag downstream',
  template: 'Install and tag a [class] spade downstream of [item]',
  color: orange,
  slug: 'install-and-tag-a-downstream-rated-spade-to',
  defaultTagged: true,
};

export const TurnSpecBlindToClosed: StepAction = {
  id: uuidv4(),
  text: 'Turn spec blind to close',
  template: 'Turn [class] spec blind to closed position and tag at [item]',
  color: orange,
  slug: 'turn-spec-blind-to-closed-position-and-tag',
  defaultTagged: true,
};

export const RemoveTagSpade: StepAction = {
  id: uuidv4(),
  text: 'Remove tag',
  template: 'Remove tag from [class] spade [item]',
  color: green,
  slug: 'remove-tag-from-spade',
  defaultTagged: true,
};
// remove-tag-from-upstream-spade
export const RemoveTagUpstreamSpade: StepAction = {
  id: uuidv4(),
  text: 'Remove tag upstream',
  template: 'Remove tag from [class] spade upstream of [item]',
  color: green,
  slug: 'remove-tag-from-upstream-spade',
  defaultTagged: true,
};
// remove-tag-from-downstream-spade
export const RemoveTagDownstreamSpade: StepAction = {
  id: uuidv4(),
  text: 'Remove tag downstream',
  template: 'Remove tag from [class] spade downstream of [item]',
  color: green,
  slug: 'remove-tag-from-downstream-spade',
  defaultTagged: true,
};

export const RemoveTagAndSpade: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and remove spade',
  template: 'Remove tag and remove [class] spade at [item]',
  color: green,
  slug: 'remove-tag-and-remove-spade',
  defaultTagged: true,
};

// remove-tag-and-remove-upstream-spade
export const RemoveTagAndUpstreamSpade: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and remove upstream spade',
  template: 'Remove tag and [class] spade from upstream of [item]',
  color: green,
  slug: 'remove-tag-and-remove-rated-upstream-spade',
  defaultTagged: true,
};
// remove-tag-and-remove-downstream-spade
export const RemoveTagAndDownstreamSpade: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and remove downstream spade',
  template: 'Remove tag and [class] spade from downstream of [item]',
  color: green,
  slug: 'remove-tag-and-remove-rated-downstream-spade',
  defaultTagged: true,
};
export const RemoveTagAndOpenSpecBlind: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and open spec blind',
  template: 'Remove tag and open [class] spec blind at [item]',
  color: green,
  slug: 'remove-tag-and-open-spec-blind',
  defaultTagged: true,
};

export const RemoveTagAndLeaveSpecBlindClosed: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and leave spec blind closed',
  template: 'Remove tag and leave [class] spec blind in closed position [item]',
  color: green,
  slug: 'remove-tag-and-leave-spec-blind-in-closed-position',
  defaultTagged: true,
};

// Blind
export const InstallBlindAndTag: StepAction = {
  id: uuidv4(),
  text: 'Install and tag',
  template: 'Install and tag a [class] blind at [item]',
  color: orange,
  slug: 'install-and-tag-a-rated-blind-to',
  defaultTagged: true,
};

export const InstallBlindAndTagUpstream: StepAction = {
  id: uuidv4(),
  text: 'Install and tag upstream',
  template: 'Install and tag a [class] blind upstream of [item]',
  color: orange,
  slug: 'install-and-tag-a-upstream-rated-blind-to',
  defaultTagged: true,
};

export const InstallBlindAndTagDownstream: StepAction = {
  id: uuidv4(),
  text: 'Install and tag downstream',
  template: 'Install and tag a [class] blind downstream of [item]',
  color: orange,
  slug: 'install-and-tag-a-downstream-rated-blind-to',
  defaultTagged: true,
};

export const InstalAndTagOnPipeWork: StepAction = {
  id: uuidv4(),
  text: 'Install and tag on pipework',
  template: 'Install and tag a [class] blind to [item] on pipework',
  color: orange,
  slug: 'install-and-tag-a-rated-blind-to-on-pipework',
  defaultTagged: true,
};

export const RemoveBlind: StepAction = {
  id: uuidv4(),
  text: 'Remove',
  template: 'Remove blind from [item]',
  color: purple,
  slug: 'remove-blind-from',
};

export const RemoveTagBlind: StepAction = {
  id: uuidv4(),
  text: 'Remove tag',
  template: 'Remove tag from [class] blind [item]',
  color: green,
  slug: 'remove-tag-from-rated-blind',
  defaultTagged: true,
};

export const RemoveTagBlindUpstream: StepAction = {
  id: uuidv4(),
  text: 'Remove tag upstream',
  template: 'Remove tag from [class] blind upstream of [item]',
  color: green,
  slug: 'remove-tag-from-upstream-blind',
  defaultTagged: true,
};

export const RemoveTagBlindDownstream: StepAction = {
  id: uuidv4(),
  text: 'Remove tag downstream',
  template: 'Remove tag from [class] blind downstream of [item]',
  color: green,
  slug: 'remove-tag-from-downstream-blind',
  defaultTagged: true,
};

export const RemoveTagAndBlind: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and remove blind',
  template: 'Remove tag and remove [class] blind from [item]',
  color: green,
  slug: 'remove-tag-and-remove-rated-blind',
  defaultTagged: true,
};

export const RemoveTagAndUpstreamBlind: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and remove upstream blind',
  template: 'Remove tag and [class] blind from upstream of [item]',
  color: green,
  slug: 'remove-tag-and-remove-rated-upstream-blind',
  defaultTagged: true,
};

export const RemoveTagAndDownstreamBlind: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and remove downstream blind',
  template: 'Remove tag and [class] blind from downstream of [item]',
  color: green,
  slug: 'remove-tag-and-remove-rated-downstream-blind',
  defaultTagged: true,
};

export const RemoveTagFromBlindOnPipework: StepAction = {
  id: uuidv4(),
  text: 'Remove tag from blind on pipework',
  template: 'Remove tag from [class] blind on [item] upstream pipework',
  color: green,
  slug: 'remove-tag-from-rated-blind-on-upstream-pipework',
  defaultTagged: true,
};

export const RemoveTagAndRemoveBlindOnPipework: StepAction = {
  id: uuidv4(),
  text: 'Remove tag and blind on pipework',
  template: 'Remove tag and remove [class] blind from [item] upstream pipework',
  color: green,
  slug: 'remove-tag-and-remove-rated-blind-from-upstream-pipework',
  defaultTagged: true,
};

export const ReinstateBlind: StepAction = {
  id: uuidv4(),
  text: 'Reinstate blind',
  template: 'Reinstate blind to [item]',
  color: pink,
  slug: 'reinstate-blind-to',
};

export const ReplaceItem: StepAction = {
  id: uuidv4(),
  text: 'Replace valve/item',
  template: 'Replace [item]',
  color: pink,
  slug: 'replace',
};

export const Valve = {
  type: 'valve',
  description: 'Valve',
  template: '[position] [type] [detail] [relation] [relativeRef]',
  options: ['safeguard'],
};

export const Spade = {
  type: 'spade',
  description: 'Spade',
  template: '[position] [type] [detail] [relation] [relativeRef]',
};

export const Blind = {
  type: 'blind',
  description: 'Blind',
  template: '[position] [type] [detail] [relation] [relativeRef]',
};

export const Pipe = {
  type: 'pipe',
  description: 'Pipe',
  template: '[position] [type] [detail] [relation] [relativeRef]',
};

export const Vessel = {
  type: 'vessel',
  description: 'Vessel',
  template: '[type] [floc]',
};

export const Instrument = {
  type: 'instrument',
  description: 'Instrument',
  template: '[type] [floc]',
};

export const Motor = {
  type: 'motor',
  description: 'Motor',
  template: '[type] [floc]',
};

export const Heater = {
  type: 'heater',
  description: 'Heater',
  template: '[type] [floc]',
};

export const Line = { type: 'line', description: 'Line', template: '[floc]' };

export const types: Array<ItemType> = [
  Valve,
  Pipe,
  Vessel,
  Instrument,
  Motor,
  Heater,
];

export const ClassTypes: string[] = [
  '- Class 150',
  '- Class 300',
  '- Class 600',
  '- 6A - Class 600',
  '- Class 1500',
  '- Class 2500',
  '- API 5000',
];

export const ActionsList: StepAction[] = [
  OpenAction,
  CloseAction,
  TagOpenAction,
  TagCloseAction,
  TagAirSupply,
  RemoveItem,
  RemovePlugCap,
  ReinstatePlugCap,
  RemoveTubing,
  RemoveManwayDoor,
  ReinstateManwayDoor,
  RemoveTagAndOpen,
  RemoveTagAndLockWireOpen,
  RemoveTagAndLeaveOpen,
  RemoveTagAndClose,
  RemoveTagAndLockWireClose,
  RemoveTagAndLeaveClose,
  TubingRemoveTagAndCap,
  ElectricallyIsolate,
  ElectricallyReinstate,
  InstallSpadeAndTag,
  InstallSpadeAndTagDownstream,
  InstallSpadeAndTagUpstream,
  TurnSpecBlindToClosed,
  RemoveTagSpade,
  RemoveTagUpstreamSpade,
  RemoveTagDownstreamSpade,
  RemoveTagAndSpade,
  RemoveTagAndUpstreamSpade,
  RemoveTagAndDownstreamSpade,
  RemoveTagAndOpenSpecBlind,
  RemoveTagAndLeaveSpecBlindClosed,
  InstallBlindAndTag,
  InstallBlindAndTagUpstream,
  InstallBlindAndTagDownstream,
  InstalAndTagOnPipeWork,
  RemoveBlind,
  RemoveTagBlindUpstream,
  RemoveTagBlindDownstream,
  RemoveTagBlind,
  RemoveTagAndUpstreamBlind,
  RemoveTagAndDownstreamBlind,
  RemoveTagAndBlind,
  RemoveTagFromBlindOnPipework,
  RemoveTagAndRemoveBlindOnPipework,
  ReinstateBlind,
  ReplaceItem,
  RemoveTagAndOpenAirSupply,
  RemoveTagAndLeaveCloseAirSupply,
];

export const actions: {
  [key: string]: Array<ItemActions>;
} = {
  valve: [
    {
      label: 'Open',
      items: [OpenAction, TagOpenAction],
      modes: [Modes.isolation],
    },
    {
      label: 'Close',
      items: [CloseAction, TagCloseAction],
      modes: [Modes.isolation],
    },
    {
      label: 'Close air supply',
      items: [TagAirSupply],
      modes: [Modes.isolation],
    },
    {
      label: 'Remove',
      items: [RemoveItem, RemovePlugCap, RemoveTubing],
      modes: [Modes.isolation],
    },
    {
      label: 'Blind',
      items: [
        InstallBlindAndTagUpstream,
        InstallBlindAndTagDownstream,
        InstalAndTagOnPipeWork,
        RemoveBlind,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Spade',
      items: [
        InstallSpadeAndTagDownstream,
        InstallSpadeAndTagUpstream,
        TurnSpecBlindToClosed,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Electrically isolate',
      items: [ElectricallyIsolate],
      modes: [Modes.isolation],
    },
    {
      label: 'Open',
      items: [
        OpenAction,
        RemoveTagAndOpen,
        RemoveTagAndLockWireOpen,
        RemoveTagAndLeaveOpen,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Close',
      items: [
        CloseAction,
        RemoveTagAndClose,
        RemoveTagAndLockWireClose,
        RemoveTagAndLeaveClose,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Tubing - remove tag and cap/plug and reconnect',
      items: [TubingRemoveTagAndCap],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Air supply',
      items: [RemoveTagAndOpenAirSupply, RemoveTagAndLeaveCloseAirSupply],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Reinstate',
      items: [ReinstatePlugCap, ReinstateBlind],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Electrically reinstate',
      items: [ElectricallyReinstate],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Blind',
      items: [
        RemoveTagBlindUpstream,
        RemoveTagBlindDownstream,
        RemoveTagAndUpstreamBlind,
        RemoveTagAndDownstreamBlind,
        RemoveTagFromBlindOnPipework,
        RemoveTagAndRemoveBlindOnPipework,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Spade',
      items: [
        RemoveTagUpstreamSpade,
        RemoveTagDownstreamSpade,
        RemoveTagAndUpstreamSpade,
        RemoveTagAndDownstreamSpade,
        RemoveTagAndOpenSpecBlind,
        RemoveTagAndLeaveSpecBlindClosed,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Replace valve/item',
      items: [ReplaceItem],
      modes: [Modes.deIsolation],
    },
  ],
  vessel: [
    {
      label: 'Blind',
      items: [
        InstallBlindAndTagUpstream,
        InstallBlindAndTagDownstream,
        InstalAndTagOnPipeWork,
        RemoveBlind,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Spade',
      items: [
        InstallSpadeAndTagDownstream,
        InstallSpadeAndTagUpstream,
        TurnSpecBlindToClosed,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Remove',
      items: [RemoveItem, RemovePlugCap, RemoveTubing, RemoveManwayDoor],
      modes: [Modes.isolation],
    },
    {
      label: 'Open',
      items: [OpenAction],
      modes: [Modes.isolation],
    },
    {
      label: 'Close',
      items: [CloseAction],
      modes: [Modes.isolation],
    },
    {
      label: 'Open',
      items: [OpenAction],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Close',
      items: [CloseAction],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Reinstate',
      items: [ReinstatePlugCap, ReinstateBlind, ReinstateManwayDoor],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Tubing - remove tag and cap/plug and reconnect',
      items: [TubingRemoveTagAndCap],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Replace valve/item',
      items: [ReplaceItem],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Blind',
      items: [
        RemoveTagBlindUpstream,
        RemoveTagBlindDownstream,
        RemoveTagAndUpstreamBlind,
        RemoveTagAndDownstreamBlind,
        RemoveTagFromBlindOnPipework,
        RemoveTagAndRemoveBlindOnPipework,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Spade',
      items: [
        RemoveTagUpstreamSpade,
        RemoveTagDownstreamSpade,
        RemoveTagAndUpstreamSpade,
        RemoveTagAndDownstreamSpade,
        RemoveTagAndOpenSpecBlind,
        RemoveTagAndLeaveSpecBlindClosed,
      ],
      modes: [Modes.deIsolation],
    },
  ],
  pipe: [
    {
      label: 'Blind',
      items: [
        InstallBlindAndTagUpstream,
        InstallBlindAndTagDownstream,
        InstalAndTagOnPipeWork,
        RemoveBlind,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Spade',
      items: [
        InstallSpadeAndTagDownstream,
        InstallSpadeAndTagUpstream,
        TurnSpecBlindToClosed,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Remove',
      items: [RemoveItem, RemovePlugCap],
      modes: [Modes.isolation],
    },
    {
      label: 'Tubing - remove tag and cap/plug and reconnect',
      items: [TubingRemoveTagAndCap],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Blind',
      items: [
        RemoveTagBlindUpstream,
        RemoveTagBlindDownstream,
        RemoveTagAndUpstreamBlind,
        RemoveTagAndDownstreamBlind,
        RemoveTagFromBlindOnPipework,
        RemoveTagAndRemoveBlindOnPipework,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Spade',
      items: [
        RemoveTagUpstreamSpade,
        RemoveTagDownstreamSpade,
        RemoveTagAndUpstreamSpade,
        RemoveTagAndDownstreamSpade,
        RemoveTagAndOpenSpecBlind,
        RemoveTagAndLeaveSpecBlindClosed,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Reinstate',
      items: [ReinstatePlugCap, ReinstateBlind],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Replace valve/item',
      items: [ReplaceItem],
      modes: [Modes.deIsolation],
    },
  ],
  motor: [
    {
      label: 'Electrically isolate',
      items: [ElectricallyIsolate],
      modes: [Modes.isolation],
    },
    {
      label: 'Remove',
      items: [RemoveItem],
      modes: [Modes.isolation],
    },
    {
      label: 'Blind',
      items: [
        InstallBlindAndTagUpstream,
        InstallBlindAndTagDownstream,
        InstalAndTagOnPipeWork,
        RemoveBlind,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Spade',
      items: [
        InstallSpadeAndTagDownstream,
        InstallSpadeAndTagUpstream,
        TurnSpecBlindToClosed,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Electrically reinstate',
      items: [ElectricallyReinstate],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Replace valve/item',
      items: [ReplaceItem],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Reinstate',
      items: [ReinstateBlind],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Tubing - remove tag and cap/plug and reconnect',
      items: [TubingRemoveTagAndCap],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Blind',
      items: [
        RemoveTagBlindUpstream,
        RemoveTagBlindDownstream,
        RemoveTagAndUpstreamBlind,
        RemoveTagAndDownstreamBlind,
        RemoveTagFromBlindOnPipework,
        RemoveTagAndRemoveBlindOnPipework,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Spade',
      items: [
        RemoveTagUpstreamSpade,
        RemoveTagDownstreamSpade,
        RemoveTagAndUpstreamSpade,
        RemoveTagAndDownstreamSpade,
        RemoveTagAndOpenSpecBlind,
        RemoveTagAndLeaveSpecBlindClosed,
      ],
      modes: [Modes.deIsolation],
    },
  ],
  instrument: [
    {
      label: 'Close air supply',
      items: [TagAirSupply],
      modes: [Modes.isolation],
    },
    {
      label: 'Electrically isolate',
      items: [ElectricallyIsolate],
      modes: [Modes.isolation],
    },
    {
      label: 'Remove',
      items: [RemoveItem, RemovePlugCap, RemoveTubing],
      modes: [Modes.isolation],
    },
    {
      label: 'Blind',
      items: [
        InstallBlindAndTagUpstream,
        InstallBlindAndTagDownstream,
        InstalAndTagOnPipeWork,
        RemoveBlind,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Spade',
      items: [
        InstallSpadeAndTagDownstream,
        InstallSpadeAndTagUpstream,
        TurnSpecBlindToClosed,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Tubing - remove tag and cap/plug and reconnect',
      items: [TubingRemoveTagAndCap],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Air supply',
      items: [RemoveTagAndOpenAirSupply, RemoveTagAndLeaveCloseAirSupply],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Electrically reinstate',
      items: [ElectricallyReinstate],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Reinstate',
      items: [ReinstatePlugCap, ReinstateBlind],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Replace valve/item',
      items: [ReplaceItem],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Blind',
      items: [
        RemoveTagBlindUpstream,
        RemoveTagBlindDownstream,
        RemoveTagAndUpstreamBlind,
        RemoveTagAndDownstreamBlind,
        RemoveTagFromBlindOnPipework,
        RemoveTagAndRemoveBlindOnPipework,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Spade',
      items: [
        RemoveTagUpstreamSpade,
        RemoveTagDownstreamSpade,
        RemoveTagAndUpstreamSpade,
        RemoveTagAndDownstreamSpade,
        RemoveTagAndOpenSpecBlind,
        RemoveTagAndLeaveSpecBlindClosed,
      ],
      modes: [Modes.deIsolation],
    },
  ],
  heater: [
    {
      label: 'Electrically isolate',
      items: [ElectricallyIsolate],
      modes: [Modes.isolation],
    },
    {
      label: 'Remove',
      items: [RemoveItem, RemovePlugCap],
      modes: [Modes.isolation],
    },
    {
      label: 'Blind',
      items: [
        InstallBlindAndTagUpstream,
        InstallBlindAndTagDownstream,
        InstalAndTagOnPipeWork,
        RemoveBlind,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Spade',
      items: [
        InstallSpadeAndTagDownstream,
        InstallSpadeAndTagUpstream,
        TurnSpecBlindToClosed,
      ],
      modes: [Modes.isolation],
    },
    {
      label: 'Electrically reinstate',
      items: [ElectricallyReinstate],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Tubing - remove tag and cap/plug and reconnect',
      items: [TubingRemoveTagAndCap],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Reinstate',
      items: [ReinstatePlugCap, ReinstateBlind, ReinstateManwayDoor],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Replace valve/item',
      items: [ReplaceItem],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Blind',
      items: [
        RemoveTagBlindUpstream,
        RemoveTagBlindDownstream,
        RemoveTagAndUpstreamBlind,
        RemoveTagAndDownstreamBlind,
        RemoveTagFromBlindOnPipework,
        RemoveTagAndRemoveBlindOnPipework,
      ],
      modes: [Modes.deIsolation],
    },
    {
      label: 'Spade',
      items: [
        RemoveTagUpstreamSpade,
        RemoveTagDownstreamSpade,
        RemoveTagAndUpstreamSpade,
        RemoveTagAndDownstreamSpade,
        RemoveTagAndOpenSpecBlind,
        RemoveTagAndLeaveSpecBlindClosed,
      ],
      modes: [Modes.deIsolation],
    },
  ],
};

// Shared mappings for spades
const sharedSpadeMappings = {
  'install-and-tag-a-rated-spade-to': [
    'remove-tag-from-spade',
    'remove-tag-and-remove-spade',
  ],
  'install-and-tag-a-upstream-rated-spade-to': [
    'remove-tag-from-upstream-spade',
    'remove-tag-and-remove-rated-upstream-spade',
  ],
  'install-and-tag-a-downstream-rated-spade-to': [
    'remove-tag-from-downstream-spade',
    'remove-tag-and-remove-rated-downstream-spade',
  ],
  'turn-spec-blind-to-closed-position-and-tag': [
    'remove-tag-and-open-spec-blind',
    'remove-tag-and-leave-spec-blind-in-closed-position',
  ],
};

// Shared mappings for blinds
const sharedBlindMappings = {
  'install-and-tag-a-rated-blind-to': [
    'remove-tag-from-rated-blind',
    'remove-tag-and-remove-rated-blind',
  ],
  'install-and-tag-a-upstream-rated-blind-to': [
    'remove-tag-from-upstream-blind',
    'remove-tag-and-remove-rated-upstream-blind',
  ],
  'install-and-tag-a-downstream-rated-blind-to': [
    'remove-tag-from-downstream-blind',
    'remove-tag-and-remove-rated-downstream-blind',
  ],
  'install-and-tag-a-rated-blind-to-on-pipework': [
    'remove-tag-from-rated-blind-on-upstream-pipework',
    'remove-tag-and-remove-rated-blind-from-upstream-pipework',
  ],
  'remove-blind-from': ['reinstate-blind-to'],
};

// Refactored actionsMappings
export const actionsMappings = {
  valve: {
    'tag-closed-air-supply-to': [
      'remove-tag-and-open-air-supply',
      'remove-tag-and-leave-close-air-supply',
    ],
    'electrically-isolate-and-tag': ['electrically-reinstate'],
    'tag-close': [
      'remove-tag-and-leave-close',
      'remove-tag-and-open',
      'remove-tag-and-lock-wire-open',
    ],
    'tag-open': [
      'remove-tag-and-leave-open',
      'remove-tag-and-close',
      'remove-tag-and-lock-wire-close',
    ],
    'remove-tubing-from-capplug-and-tag': [
      'remove-tag-and-cap-reconnect-tubing-to',
    ],
    close: ['open'],
    open: ['close'],
    'remove-plugcap-from': ['reinstate-capplug-to'],
    remove: ['replace'],
    ...sharedSpadeMappings,
    ...sharedBlindMappings,
  },
  vessel: {
    'remove-tubing-from-capplug-and-tag': [
      'remove-tag-and-cap-reconnect-tubing-to',
    ],
    close: ['open'],
    open: ['close'],
    'remove-plugcap-from': ['reinstate-capplug-to'],
    'remove-manway-door-from': ['reinstate-manway-door-to'],
    remove: ['replace'],
    ...sharedSpadeMappings,
    ...sharedBlindMappings,
  },
  pipe: {
    'remove-plugcap-from': ['reinstate-capplug-to'],
    remove: ['replace'],
    ...sharedSpadeMappings,
    ...sharedBlindMappings,
  },
  motor: {
    'electrically-isolate-and-tag': ['electrically-reinstate'],
    remove: ['replace'],
    ...sharedSpadeMappings,
    ...sharedBlindMappings,
  },
  instrument: {
    'tag-closed-air-supply-to': [
      'remove-tag-and-open-air-supply',
      'remove-tag-and-leave-close-air-supply',
    ],
    'electrically-isolate-and-tag': ['electrically-reinstate'],
    'remove-tubing-from-capplug-and-tag': [
      'remove-tag-and-cap-reconnect-tubing-to',
    ],
    'remove-plugcap-from': ['reinstate-capplug-to'],
    remove: ['replace'],
    ...sharedSpadeMappings,
    ...sharedBlindMappings,
  },
  heater: {
    'electrically-isolate-and-tag': ['electrically-reinstate'],
    'remove-plugcap-from': ['reinstate-capplug-to'],
    'remove-manway-door-from': ['reinstate-manway-door-to'],
    remove: ['replace'],
    ...sharedSpadeMappings,
    ...sharedBlindMappings,
  },
};
